<template>
  <div
    class="dui-popover"
    :class="{ 'open': vm.isOpen }"
  >
    <div
      ref="trigger"
      class="trigger"
      @click="toggleOpen"
    >
      <slot name="trigger" />
    </div>
    <div
      class="content-container"
      :style="{ width: contentWidth + 'px' }"
    >
      <div class="content">
        <slot name="content" />
      </div>
    </div>
  </div>
</template>

<script>
import contextMenuMixin from '@dui/mixins/context-menu';

export default {
  mixins: [
    contextMenuMixin,
  ],
  props: {
    contentWidth: {
      type: Number,
      default: null,
    },
    hover: {
      type: Boolean,
      default: false,
    },
  },
  beforeDestroy() {
    this.removePopoverEventListeners();
  },
  mounted() {
    this.addPopoverEventListeners();
  },
  methods: {
    // Events
    addPopoverEventListeners() {
      if (!this.hover) {
        return;
      }
      this.$el.addEventListener('mouseover', this.mouseoverPerformed);
      this.$el.addEventListener('mouseout', this.mouseoutPerformed);
    },
    removePopoverEventListeners() {
      if (!this.hover) {
        return;
      }
      this.$el.removeEventListener('mouseover', this.mouseoverPerformed);
      this.$el.removeEventListener('mouseout', this.mouseoutPerformed);
    },
    mouseoutPerformed() {
      this.toggleOpen(false);
    },
    mouseoverPerformed() {
      this.toggleOpen(true);
    },
    // END Events
  },
};
</script>

<style lang="scss" scoped>
@import "@dui-styles/base";

.dui-popover {
  display: inline-block;

  @include makePopoverContainer();
}
</style>
